<template>
  <div class="panel panel-default" v-if="resourceDocs && resourceDocs.length > 0">
    <div class="panel-heading">
      <h4>Related Assessment Resources</h4>
    </div>
    <div class="panel-body">
      <ul class="list-unstyled">
        <li v-for="(res, index) in resourceDocs" :key="index">
          <ResourcePreviewCard
            :uuid="res.uuid"
            :title="res.title"
            :description="res.description"
            :type="res.type"
            :thumbnail_url="res.thumbnail_url"
            :grades="res.grades"
            :subjects="res.subjects"
            :download_links="res.download_links"
            :google_drive_links="res.google_drive_links"
            :show-thumbnail="false"
            :collapsible-description="true"/>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex'
import ResourcePreviewCard from '@/components/ResourcePreviewCard'

export default {
  name: 'PresentLevelsResourceDocs',
  components: {
    ResourcePreviewCard
  },
  computed: {
    ...mapState('presentlevels', ['resourceDocs'])
  }
}
</script>

<style scoped>
</style>
